// NodeMissionProgress.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './NodeMissionProgress.css';

/**
 * NodeMissionProgress
 * 
 * Displays the progress track for a Mission card.
 *
 * @param {boolean} hasRun - Whether the Mission has a run.
 * @param {object} missionProgress - Mission completion progress.
 *  
 *
 * @returns {ReactNode} - NodeMissionProgress.
 */
const NodeMissionProgress = React.memo(({ hasRun, missionProgress }) => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- RENDER ----- //

    return (

        <div
          className="node-mission-progress-container"
        >
            {/* PROGRESS FILL */}
            <div
              className="node-mission-progress-fill"
              style={{
                    backgroundColor: theme.green,
                    width: `${hasRun ? missionProgress.percent : 0}%`,
                }}
            />
        </div>
    );

});

// Dev Tools
NodeMissionProgress.displayName = 'NodeMissionProgress';

export default NodeMissionProgress;
